import React, { createContext, useState } from 'react';
import { IStepperProps, IStepperContext, IStepperComposition } from './types';
import { Step } from './step';
import { Well } from '../form';

export const StepperContext = createContext<IStepperContext | undefined>(
  undefined,
);

const Stepper: React.FC<IStepperProps> & IStepperComposition = ({
  cancelPath,
  children,
  onFinish,
}) => {
  const [activeStep, setActiveStep] = useState<number>(1);

  const steps = React.Children.toArray(children).filter(
    (child) => React.isValidElement(child) && child.type === Step,
  );

  const numberOfChildren = steps.length;

  return (
    <StepperContext.Provider
      value={{
        cancelPath,
        activeStep,
        numberOfSteps: numberOfChildren,
        hasNext: activeStep < numberOfChildren,
        hasPrevious: activeStep > 1,
        showNext: () => setActiveStep(activeStep + 1),
        showPrevious: () => setActiveStep(activeStep - 1),
        onFinish: onFinish,
      }}
    >
      <Well>{steps[activeStep - 1]}</Well>
    </StepperContext.Provider>
  );
};

Stepper.Step = Step;

export default Stepper;
